import { useEffect, useRef, useState } from 'react';
import { GUEST_RESERVATION_COUNTDOWN_SECONDS } from './guestReservationFormConstants';

export function useGuestReservationCountdown(
  isOpen: boolean,
  itemId: string,
  t: (key: string) => string,
  checkIn: string,
  checkOut: string,
) {
  const [timeRemaining, setTimeRemaining] = useState(GUEST_RESERVATION_COUNTDOWN_SECONDS);
  const [hasStarted, setHasStarted] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const startTimeRef = useRef<number | null>(null);

  // Timer only runs once the form is open AND both dates are confirmed
  const shouldRun = isOpen && !!checkIn && !!checkOut;

  useEffect(() => {
    if (shouldRun) {
      // Only (re)start if not already running
      if (!startTimeRef.current) {
        startTimeRef.current = Date.now();
        setTimeRemaining(GUEST_RESERVATION_COUNTDOWN_SECONDS);
        setHasStarted(true);

        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }

        intervalRef.current = setInterval(() => {
          if (startTimeRef.current) {
            const elapsed = Math.floor((Date.now() - startTimeRef.current) / 1000);
            const remaining = Math.max(0, GUEST_RESERVATION_COUNTDOWN_SECONDS - elapsed);
            setTimeRemaining(remaining);

            if (remaining === 0) {
              if (intervalRef.current) {
                clearInterval(intervalRef.current);
              }
              alert(t('guestReservation.timeExpired'));
            }
          }
        }, 1000);
      }
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      startTimeRef.current = null;
      setTimeRemaining(GUEST_RESERVATION_COUNTDOWN_SECONDS);
      setHasStarted(false);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [shouldRun, itemId, t]);

  return { timeRemaining, hasStarted };
}
